import { NotificationInstance } from 'antd/es/notification/interface';
import { createContext } from 'react';

export interface ToastContextType {
    notification: NotificationInstance;
}

export default createContext<ToastContextType>(undefined as any);
